let domLoaded = false;
let igReady = false;

// Kaching product-id swap for paid search visitors, Murphy/Leadership only.
// Same mechanism as the Snuggi price test on ab-test/V_PIL_PDP_04.
const KACHING_SWAP_TARGET_BY_PRODUCT_ID = {
  7568898293894: "7733150187654", // murphys-law-for-kids -> swap to this id
  7587123658886: "7733149794438", // leadership-enlightenment-for-kids -> swap to this id
};
const kachingSwapProductId =
  KACHING_SWAP_TARGET_BY_PRODUCT_ID[String(window.__productIdFromTemplate)];
let kachingSwapAttempted = false;

function kachingWaitForInit(onReady, retriesLeft = 25) {
  if (typeof window.__kachingBundlesInitializeInternal === "function") {
    onReady();
    return;
  }
  if (retriesLeft <= 0) return;
  setTimeout(() => kachingWaitForInit(onReady, retriesLeft - 1), 200);
}

const KACHING_SWAP_ATTEMPT_TIMEOUT = 4000;
const KACHING_SWAP_MAX_ATTEMPTS = 3;

function decideKachingSwap(isPaidSearch) {
  if (kachingSwapAttempted || !kachingSwapProductId || !isPaidSearch) {
    return;
  }
  kachingSwapAttempted = true;
  kachingWaitForInit(() => kachingAttemptSwap(1));
}

function kachingAttemptSwap(attempt) {
  const oldEl = document.querySelector("kaching-bundle");
  const parent = oldEl?.parentNode;
  if (!oldEl || !parent) return;

  const nextSibling = oldEl.nextSibling;
  oldEl.remove();

  const newEl = document.createElement("kaching-bundle");
  Array.from(oldEl.attributes).forEach((attr) =>
    newEl.setAttribute(attr.name, attr.value)
  );
  newEl.setAttribute("product-id", kachingSwapProductId);
  newEl.removeAttribute("data-initialized");
  parent.insertBefore(newEl, nextSibling);

  let settled = false;

  const retryOrGiveUp = () => {
    if (settled) return;
    settled = true;
    obs.disconnect();
    clearTimeout(fallback);
    newEl.remove();
    parent.insertBefore(oldEl, nextSibling);
    if (attempt < KACHING_SWAP_MAX_ATTEMPTS) kachingAttemptSwap(attempt + 1);
  };

  const fallback = setTimeout(() => {
    if (newEl.children.length === 0) retryOrGiveUp();
    settled = true;
    obs.disconnect();
  }, KACHING_SWAP_ATTEMPT_TIMEOUT);

  const obs = new MutationObserver(() => {
    if (settled || newEl.children.length === 0) return;
    settled = true;
    obs.disconnect();
    clearTimeout(fallback);
  });
  obs.observe(newEl, { childList: true });

  window.__kachingBundlesInitializeInternal();
}

// Validare Holdout. Permanent, never end it.
const HOLDOUT_EXPERIMENT_ID = "3ad2181f-d285-418c-b4d8-a52ce3a136a1";
const HOLDOUT_GROUP_ID = "c41ea5b4-45b8-4edf-8687-844be31c4054";

// QA only: ?validare_qa=optimized forces the Optimized bucket for this browser
// session (Intelligems preview links put you in the holdout's Control = Holdout).
// ?validare_qa=off clears it. Real visitors never have this flag.
function isQaForcedOptimized() {
  try {
    const p = new URLSearchParams(location.search).get("validare_qa");
    if (p === "optimized") sessionStorage.setItem("validare_qa", "optimized");
    if (p === "off") sessionStorage.removeItem("validare_qa");
    return sessionStorage.getItem("validare_qa") === "optimized";
  } catch (e) {
    return false;
  }
}

function handleExperiments() {
  if (!domLoaded || !igReady) return;

  // Holdout: V_PRIME_HOLDOUT_G1 (do not edit)
  const isHeldOut =
    !isQaForcedOptimized() &&
    window.igData?.user.getTestGroup(HOLDOUT_EXPERIMENT_ID)?.id ===
      HOLDOUT_GROUP_ID;
  document.body.classList.add(
    isHeldOut ? "c-validareHoldout" : "c-validareOptimized"
  );
  try {
    localStorage.setItem("validare_holdout", isHeldOut ? "1" : "0");
  } catch (e) {}

  decideKachingSwap(
    document.documentElement.classList.contains("c-paidSearchVisitor")
  );

  // Test: V_PRIME_MIX_30 | PDP Gift-Threshold Progress Bar (BFCM)
  const primeMix30 = window.igData?.user.getTestGroup(
    "d6e0d425-a1eb-4507-9ff9-eb899b475a2f"
  );
  if (primeMix30?.name === "Var A") {
    document.body.classList.add("c-primeMix30VarA");
  }

  // Test: V_PRIME_PDP_28 | Book preview - flip-through video / GIF
  const primePdp28 = window.igData?.user.getTestGroup(
    "66574245-f027-46f5-b222-c4502a7fc974"
  );
  if (primePdp28?.id === "5fe62e3d-4f51-4aa0-ace3-7677566b119a") {
    document.body.classList.add("c-primePdp28VarA");
  } else if (primePdp28?.id === "6d52d967-9a79-4666-83a1-a10372d71ef0") {
    document.body.classList.add("c-primePdp28VarB");
  } else if (primePdp28?.id === "40ecc2d2-54aa-4785-96ae-41c8ae84482d") {
    document.body.classList.add("c-primePdp28VarC");
  }

  // Test: V_PRIME_PDP_40 | PDP Percent Sold Urgency Bar: Encyclopedia Only vs All PDPs
  const primePdp40 = window.igData?.user.getTestGroup(
    "6afa5409-05f0-4834-ab3b-2ff768ea56a0"
  );
  if (primePdp40?.id === "e9346f9f-92a3-40f6-88cf-0321a8641a06") {
    document.body.classList.add("c-primePdp40VarA");
  } else if (primePdp40?.id === "d027c6a8-f57d-4845-80ff-5e74132f801f") {
    document.body.classList.add("c-primePdp40VarB");
  }

  // Test: V_PRIME_MIX_42 | 3-Book and 5-Book Bundle Price Increase
  const primeMix42 = window.igData?.user.getTestGroup(
    "e07e6faf-b6c7-49e7-a832-77e371676958"
  );
  if (primeMix42?.id === "a355532a-8652-4aaa-be12-cb6aa7cee4dc") {
    document.body.classList.add("c-primeMix42VarA"); // 5-book +$10 only
  } else if (primeMix42?.id === "29888aae-3f58-4464-8ac4-02701d30f0ad") {
    document.body.classList.add("c-primeMix42VarB"); // both +$5
  } else if (primeMix42?.id === "abd2f5d3-7479-412e-9378-20f8dbf94831") {
    document.body.classList.add("c-primeMix42VarC"); // 3-book +$5 only
  }
}

let cartDrawerWasActive = false;
setInterval(() => {
  const el = document.querySelector("cart-drawer");
  if (!el) return;
  const isActive = el.classList.contains("active");
  if (isActive && !cartDrawerWasActive) {
    cartDrawerWasActive = true;
    window.igEvents = window.igEvents || [];
    window.igEvents.push({ event: "cartDrawerOpen" });
    window.igEvents.push({ event: "view_cart" });
  } else if (!isActive) {
    cartDrawerWasActive = false;
  }
}, 200);

// Event: click_gallery_thumnail - Fires when users engage with the PDP gallery thumbnails
document.addEventListener("click", (event) => {
  const thumbnail = event.target.closest(".thumbnail-list__item .thumbnail");
  if (!thumbnail) return;
  window.igEvents = window.igEvents || [];
  window.igEvents.push({ event: "click_gallery_thumnail" });
});

// Held-out visitors get Control in every test. Runs before handleExperiments().
function holdOutFromAllTests() {
  const user = window.igData?.user;
  if (!user || user.validareHoldoutApplied || isQaForcedOptimized()) return;
  if (user.getTestGroup(HOLDOUT_EXPERIMENT_ID)?.id !== HOLDOUT_GROUP_ID) return;
  try {
    const getTestGroup = user.getTestGroup.bind(user);
    user.getTestGroup = (id) =>
      id === HOLDOUT_EXPERIMENT_ID ? getTestGroup(id) : null;
    user.validareHoldoutApplied = true;
  } catch (e) {}
}

document.addEventListener("DOMContentLoaded", () => {
  domLoaded = true;
  handleExperiments();
});

window.addEventListener("ig:ready", () => {
  holdOutFromAllTests();
  igReady = true;
  handleExperiments();
});
